import { Box, BoxProps } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { Replace } from '$utils/replace';

import { components } from './components';
import { tagStyles } from './tag-styles';

export function Markdown({
  children,
  ...props
}: Replace<BoxProps, { children: string }>) {
  return (
    <Box {...props} sx={{ ...tagStyles, ...props.sx }}>
      <ReactMarkdown components={components} rehypePlugins={[rehypeRaw]}>
        {children}
      </ReactMarkdown>
    </Box>
  );
}
